<template>
  <div :style="[{'background-color': bgColor}, {'min-height': `calc(${minHeight} + 52px)`}, {'max-height': maxHeight}]" class="card card-number" :class="`rounded-${rounded}`">
    <div v-if="number" class="number">
      {{ number }}
    </div>
    <template v-if="$slots.default">
      <slot />
    </template>
  </div>
</template>

<script>
export default {
  name: 'CardWithNumber',
  props: {
    bgColor: {
      type: String,
      default: ''
    },
    minHeight: {
      type: String,
      default: 'auto'
    },
    maxHeight: {
      type: String,
      default: 'auto'
    },
    number: {
      type: [String, Number],
      default: null
    },
    rounded: {
      type: String,
      default: '16'
    }
  }
}
</script>

<style scoped lang="scss">
.card-number {
  position: relative;
  .number {
    position: absolute;
    left: 50%;
    top: -30px;
    transform: translate(-50%, 0);
    width: 61px;
    height: 61px;
    border-radius: 100%;
    background-color: #1A5CAC;
    font-family: 'Bree Serif', sans-serif;
    font-size: 28px;
    text-align: center;
    color: #fff;
    line-height: 55px;

    @media screen and (min-width: 768px) {
      width: 90px;
      height: 90px;
      font-size: 48px;
      line-height: 80px;
      top: -50px;
    }
  }
}
</style>
